import { createI18n } from 'vue-i18n'

// Об'єкт із перекладами
const messages = {
    en: {
        tags: {
            spicy: 'spicy',
            vegan: 'vegan',
            allergens: 'allergic',
            new: 'new',
            vegetarian: 'vegetarian',
            'gluten-free': 'gluten-free',
            'medium-spicy': 'medium spicy',
            'bestseller': 'bestseller',
            'chef-recommended': 'chef recommended',
            'alcoholic': 'alcoholic',
            'non-alcoholic': 'non-alcoholic',
        },

        allergens: {
            sesame: 'sesame',
            peanuts: 'peanuts',
            soybeans: 'soybeans',
            milk: 'milk',
            mustard: 'mustard',
            lupin: 'lupin',
            'gluten-grains': 'gluten grains',
            'crustaceans': 'crustaceans',
            eggs: 'eggs',
            fish: 'fish',
            nuts: 'nuts',
            celery: 'celery',
            shellfish: 'shellfish',
            'sulfur-dioxide-sulphites': 'sulfur dioxide sulphites',
            honey: 'honey',
            citrus: 'citrus'
        }
    },
    uk: {
        tags: {
            spicy: 'Гостре',
            vegan: 'Веган',
            allergens: 'Містить алергени',
            new: 'Новинка',
            vegetarian: 'Вегетаріанське',
            'gluten-free': 'Безглютенове',
            'medium-spicy': 'Середньо-гостре',
            'bestseller': 'Хіт продажу',
            'chef-recommended': 'Рекомендовано шефом',
            'alcoholic': 'Алкогольне',
            'non-alcoholic': 'Безалкогольне',
        },

        allergens: {
            sesame: 'кунжут',
            peanuts: 'арахіс',
            soybeans: 'соя',
            milk: 'молоко',
            mustard: 'гірчиця',
            lupin: 'люпин',
            'gluten-grains': 'глютенові крупи',
            'crustaceans': 'ракоподібні',
            eggs: 'яйця',
            fish: 'риба',
            nuts: 'горіхи',
            celery: 'селера',
            shellfish: 'молюски',
            'sulfur-dioxide-sulphites': 'діоксид сірки та сульфіти',
            honey: 'мед',
            citrus: 'цитрус'
        }
    }
}

// Створення i18n інстансу
const i18n = createI18n({
    locale: 'uk', // Мова за замовчуванням
    fallbackLocale: 'en', // Запасна мова, якщо немає перекладу
    messages
})

export default i18n
